// src/pages/DebtStudio/lib/dateUtils.js

// Parse 'YYYY-MM-DD' as a LOCAL date (no UTC shift)
export function parseISODateLocal(iso) {
  if (!iso) return null;
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, (m ?? 1) - 1, d ?? 1); // local time
}

export function addMonths(date, m) {
  const d = new Date(date);
  const day = d.getDate();
  d.setMonth(d.getMonth() + m);
  if (d.getDate() < day) d.setDate(0); // month-end roll
  return d;
}

export function fmtISODate(d) {
  // Format using LOCAL components (matches parseISODateLocal)
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function dayCount30360US(d1, d2) {
  const D1 = new Date(d1), D2 = new Date(d2);
  let d1d = D1.getDate(), d2d = D2.getDate();
  const d1m = D1.getMonth() + 1, d2m = D2.getMonth() + 1;
  const d1y = D1.getFullYear(), d2y = D2.getFullYear();
  if (d1d === 31) d1d = 30;
  if (d2d === 31 && d1d === 30) d2d = 30;
  const days = (d2y - d1y) * 360 + (d2m - d1m) * 30 + (d2d - d1d);
  return days / 360;
}
